const CONFIG = 
    {
        supabaseSecretKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZzc2tnZm9iamJlZG9qdm1pbGt0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTk0NzgxMjIsImV4cCI6MjAzNTA1NDEyMn0.iYAtSmKfnwLdOlMGqBg11lDia0vBAvieqFuORTJ38D0",
        supabaseUrl: "https://vsskgfobjbedojvmilkt.supabase.co",
    }
  ;


export default CONFIG;